import { useEffect, useState } from 'react';
// A wrapper for "JSON.parse()"" to support "undefined" value
const parseJSON = (value) => {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (error) {
        console.log('parsing error on', { value });
        return undefined;
    }
};
const useLocalStorage = (key, initialValue) => {
    // Get from local storage then
    const readValueFn = () => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    };
    // Pass a initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(readValueFn);
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (newValue) => {
        // Prevent build error "window is undefined" but keeps working
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(newValue));
            // Save state
            setStoredValue(newValue);
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    };
    useEffect(() => {
        setStoredValue(readValueFn());
    }, []);
    return [storedValue, setValue];
};
export { useLocalStorage };
//# sourceMappingURL=data:application/json;base64,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